// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentWishListsStyles } from "@guestsupply/Overrides/Widgets/Common/RecentWishLists";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

recentWishListsStyles.wishListCardGridItem = {
    width: 12,
    css: css`
        padding: 0;
    `,
};

recentWishListsStyles.wishListCard = {
    actionAddToCartButton: {
        variant: "primary",
        color: "primary",
        typographyProps: {
            size: 14,
        },
    },
    basicInfoGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            align-items: center;
        `,
    },
    extendedInfoGridItem: {
        width: [12, 12, 7, 7, 7],
        align: "middle",
        css: css`
            align-items: center;
        `,
    },
    sharingStatusGridItem: {
        width: 12,
        css: css`
            justify-content: start;
            align-items: center;
            font-size: 12px;
            line-height: 13px;
            padding-top: 12px;
            ${xScreen("lte", "md")} {
                justify-content: flex-start;

                &:empty {
                    display: none;
                }
            }
        `,
    },
};

recentWishListsStyles.cardListStyles = {
    gridContainer: {
        gap: 40,
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
            }
        `,
        css: css`
            &&& {
                padding-right: 0;
                padding-left: 0;
            }
        `,
    },
};

recentWishListsStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            border-bottom: 1px solid ${color("common.border")};
            &:nth-child(2) > ${GridItemStyle} {
                padding-top: 0;
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 22px 0 28px;
        `,
    },
};

recentWishListsStyles.noWishListsGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};

recentWishListsStyles.noWishListsText = {
    ...dataTableStyles.noResultsText,
};
